export { default as MarketingCard } from './MarketingCard';
